(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-slider"] && !Shopify.designMode) return;
  try {
    
  function initHeroSlider(root){
    if (root.dataset.hsliderInit === '1') return;
    root.dataset.hsliderInit = '1';

    var track  = root.querySelector('.hslider__track');
    if (!track) return;
    var slides = track.children;
    if (!slides || slides.length < 2) return;

    var dots   = root.querySelectorAll('.hslider__dot');
    var arrows = root.querySelectorAll('.hslider__arrow');
    var autoplay = root.dataset.autoplay === 'true';
    var loop     = root.dataset.loop !== 'false';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var i = 0, timer = null;

    function go(n){
      if (loop) i = (n + slides.length) % slides.length;
      else i = Math.max(0, Math.min(slides.length - 1, n));
      for (var k = 0; k < slides.length; k++) {
        slides[k].classList.toggle('is-active', k === i);
      }
      dots.forEach(function(d, k){
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    arrows.forEach(function(a){
      a.addEventListener('click', function(e){
        e.preventDefault();
        go(i + parseInt(a.dataset.dir, 10));
        restart();
      });
    });
    dots.forEach(function(d){
      d.addEventListener('click', function(e){
        e.preventDefault();
        go(parseInt(d.dataset.i, 10));
        restart();
      });
    });

    function start(){ if (autoplay && !timer) timer = setInterval(function(){ go(i + 1); }, interval); }
    function stop(){ if (timer) { clearInterval(timer); timer = null; } }
    function restart(){ stop(); start(); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    var x0 = null;
    root.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', function(e){
      if (x0 == null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 40) { go(i + (dx < 0 ? 1 : -1)); restart(); }
      x0 = null;
    });

    start();
  }

  function bootAllHeroSliders(){
    document.querySelectorAll('[data-section-type="hero-slider"]').forEach(initHeroSlider);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAllHeroSliders);
  } else {
    bootAllHeroSliders();
  }
  // Re-init in theme editor (when section is added/reloaded)
  document.addEventListener('shopify:section:load', function(e){
    var root = e.target.querySelector('[data-section-type="hero-slider"]');
    if (root) initHeroSlider(root);
  });

  } catch(e) { console.error(e); }
})();
})();
